import * as React from 'react';
export const movedSvg = React.forwardRef(function movedSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 5.5H4a3 3 0 0 0-3 3V14a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-1.5h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H8.621a1.5 1.5 0 0 0-1.06.44L5.439 2.56A1.5 1.5 0 0 0 5 3.622V5.5Zm8.5 5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8.75a.75.75 0 0 0-1.5 0v1.75a2 2 0 0 0 2 2h1.5V14a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V8.5A1.5 1.5 0 0 1 4 7h6.364l-1.21 1.43a.65.65 0 1 0 .992.84l2.2-2.6a.65.65 0 0 0 0-.84l-2.2-2.6a.65.65 0 1 0-.992.84l1.21 1.43H6.5V3.621L8.621 1.5H13a.5.5 0 0 1 .5.5v8.5Z',
    }),
  );
});
movedSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var moved = {
  category: 'icon',
  colorable: true,
  name: 'moved',
  svg: movedSvg,
};
